"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedCurrency = void 0;
exports.supportedCurrency = {
    RUB: '₽',
    KZT: '₸',
};
